module.exports = __webpack_public_path__ + "static/brand-gkgd-7c9077b0a6f23c55ad183ed278075e39.png";